/**
 * The one way to open an accessory's SELECTION dialog from outside its form.
 *
 * Legacy has three such callers and every one of them clicks the accessory
 * form's own "Select" label rather than reaching for the selector directly:
 *
 *   canvas.view3d.js:1023   double-click on a HOOD/DAMPER/LOUVER/OPENING shape
 *   error.log.js:238        error-log row for a selectable accessory
 *   accessory_view.js:1100  auto-open after an accessory is created
 *
 *     document.querySelector(`#forms_accessory_${id} label.active-mode`)?.click()
 *
 * The label is `AccessorySelectHeading`'s (accessoryFieldKit.tsx), and it owns
 * the whole activation contract — the second-click-closes toggle, the staging
 * model, and the `rating_mode:activate` payload built from the form shim. That
 * payload cannot be reconstructed from an accessory id alone, which is why
 * legacy clicks the label and why this does too: the accessory forms are
 * mounted eagerly (TabAccessories), so the label is in the DOM whether or not
 * the row is expanded.
 *
 * Only these four types render a Select heading, matching legacy's own type
 * gate; anything else has no selection dialog and the caller falls back to the
 * section's rating dialog.
 */
export const SELECTABLE_ACCESSORY_TYPES = ['damper', 'louver', 'hood', 'opening'];

export function openAccessorySelectionDialog(accessoryId: number): boolean {
  const label = document.querySelector<HTMLElement>(
    `#forms_accessory_${accessoryId} label.active-mode`
  );
  if (!label) return false;
  label.click();
  return true;
}
